export default "__VITE_ASSET__60df1afb__"